if (!customElements.get('rise-paidy-info')) {
  customElements.define('rise-paidy-info', class extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      const trigger = this.querySelector('.rp-paidy-info-button');
      const dialog = this.querySelector('dialog');
      const close = this.querySelector('.rp-paidy-close');
      trigger.addEventListener('click', () => {
        if (typeof dialog.showModal !== 'function') { window.location.href = '/pages/ftm-paidy'; return; }
        dialog.showModal();
      });
      close.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => { if (trigger.isConnected) trigger.focus({preventScroll: true}); });
    }
  });
}
